import { Dropdown } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import svg36 from "../../assets/svg/svg36.svg";
import { useSelector } from "react-redux";

const data = [
  { month: "JAN", value: 500, maxValue: 6000, lineValue: 3000 },
  { month: "FEB", value: 2000, maxValue: 6000, lineValue: 2500 },
  { month: "MAR", value: 3000, maxValue: 6000, lineValue: 1500 },
  { month: "APR", value: 500, maxValue: 6000, lineValue: 1200 },
  { month: "MAY", value: 2000, maxValue: 6000, lineValue: 2800 },
  { month: "JUN", value: 3000, maxValue: 6000, lineValue: 4500 },
  { month: "JUL", value: 3000, maxValue: 6000, lineValue: 4300 },
  { month: "AUG", value: 1500, maxValue: 6000, lineValue: 3200 },
  { month: "SEP", value: 500, maxValue: 6000, lineValue: 2000 },
];

const CustomDot = (props) => {
  const { cx, cy, payload } = props;
  if (payload.month === "JUN") {
    return (
      <circle
        cx={cx}
        cy={cy}
        r={8}
        fill="#F9C784"
        stroke="white"
        strokeWidth={2}
      />
    );
  }
  return null;
};
const settingItems = [
  {
    key: "1",
    label: (
      <div
      //  onClick={handleEdit}
      >
        <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
          1
        </Link>
      </div>
    ),
  },
  {
    key: "2",
    label: (
      <div
      // onClick={handleView}
      >
        <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
          2
        </Link>
      </div>
    ),
  },
];

const FarmersGraph = () => {
  const url = "api/v2/dashboard/getAllDashboardData";

  const data = useSelector((state) => state.fetch.data[url] || []);

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white   w-full h-full">
      <div className="flex items-center justify-between w-full ">
        <div className="text-[#424242] text-[.75rem] font-[500] font-interSans">
          FLID
        </div>

        <div className="flex lg:flex-row flex-col lg:items-center gap-[.62rem]">
          <div className="flex items-center gap-x-[.62rem]">
            <div className="h-[0.6875rem] w-[0.6875rem] flex items-center justify-center bg-[#0092CC] rounded-full"></div>
            <div className="text-[#615E83] text-[.75rem] font-interSans font-[400]">
              Number of Farmers 34K
            </div>
          </div>

          <div className="flex items-center gap-x-[.62rem]">
            <div className="h-[0.6875rem] w-[0.6875rem] flex items-center justify-center bg-[#F7D9A8] rounded-full"></div>
            <div className="text-[#615E83] text-[.75rem] font-interSans font-[400]">
              Expressed Interests 16K
            </div>
          </div>
        </div>

        <Dropdown
          overlayStyle={{
            width: "250px",
          }}
          trigger={"click"}
          menu={{ items: settingItems }}
          placement="bottom"
        >
          <button
            className="rounded-[.5rem] bg-[#F1F3F5] flex py-[.25rem] px-[.5rem] items-center gap-[.25rem]
                            text-[#424242] font-interSans font-[400] text-[.75rem]"
          >
            2024
            <img src={svg36} alt="svg36" />
          </button>
        </Dropdown>
      </div>

      <div className="w-full h-full mt-[2rem]">
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart
            data={data?.flidFarmersData}
            margin={{ left: 0, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="mon" />
            <YAxis
            //  tickFormatter={(value) => `${value / 1000}k`}
            />
            <Tooltip />

            {/* Filled teal bars */}
            <Bar
              dataKey="value"
              stackId="a"
              barSize={15}
              fill="#2CA6A4"
              radius={[4, 4, 0, 0]}
            />

            {/* Upper grey bars with same width */}
            <Bar
              dataKey={(d) => d.total - d.value}
              stackId="a"
              barSize={15}
              fill="#E6E6F0"
            />

            {/* Orange line */}
            <Line
              type="monotone"
              dataKey="expressions"
              stroke="#F9C784"
              strokeWidth={2}
              dot={<CustomDot />}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default FarmersGraph;
